import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { EnvironmentService } from '../core/environment.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    private environmentService = inject(EnvironmentService);


    intercept(req: HttpRequest<any>, next: HttpHandler) {
        // Get the auth token from the service.
        let authToken = 'some-auth-token';
        if (this.environmentService.systemUser?.token) {
            authToken = this.environmentService.systemUser.token;
        }
        /*
        * The verbose way:
        // Clone the request and replace the original headers with
        // cloned headers, updated with the authorization.
        const authReq = req.clone({
          headers: req.headers.set('Authorization', authToken)
        });
        */
        // Clone the request and set the new header in one step.
        let authReq = req;
        if (req.url.indexOf('changepassword') === -1) {
            authReq = req.clone({ setHeaders: { 'X-AUTH-TOKEN': authToken } });
        }

        // send cloned request with header to the next handler.
        return next.handle(authReq);
        // send cloned request with header to the next handler.
        // return next.handle(authReq).pipe(
        //     catchError(
        //         (err: any) => {
        //             //this.appService.errorHandling('','Nicht authorisierter Zugriff. Token nicht vorhanden oder ungültig. Melden Sie sich bitte erneut an.')(err);
        //             return throwError(err);
        //         }
        //     )
        // );
    }
}
